import Header from "../../components/Header";
import { MascaraCpf } from "../../../utils/MascaraCpf";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Typography, Breadcrumbs, Link, Button, Card, Divider, TextField, Autocomplete, MenuItem, Select, Checkbox, FormControlLabel, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, FormControl, InputLabel, OutlinedInput, FormHelperText, Tabs, Tab, Chip, Alert, Avatar, Stack, Dialog, DialogTitle, DialogContent, DialogActions, Accordion, AccordionSummary, AccordionDetails, Tooltip, } from "@mui/material";
import { Visibility, VisibilityOff, Email as EmailIcon, VerifiedUser as VerifiedUserIcon, PictureAsPdf as PictureAsPdfIcon, ErrorOutline as ErrorOutlineIcon, InsertDriveFileOutlined as ArquivoIcon, RotateLeft as RotateLeftIcon, RotateRight as RotateRightIcon, ExpandMore as ExpandMoreIcon, ContentCopy as ContentCopyIcon, DeleteOutline as DeleteOutlineIcon, FileDownloadOutlined as DownloadIcon, CancelOutlined as CancelOutlinedIcon, Refresh as RefreshIcon, ReceiptLongOutlined as NotasIcon, } from "@mui/icons-material";
import { MascaraCnpj } from "../../../utils/MascaraCnpj";
import { TirarMascara } from "../../../utils/TirarMascara";
import { MascaraValor } from "../../../utils/MascaraValor";
import { MascaraCep } from "../../../utils/MascaraCep";
import { statusNota, podeBaixarPdf, podeCancelar, tomadorNota, mensagemNota, numeroNota } from "../../../utils/StatusNotaFiscal";
import ModalMotivoCancelamentoNfse from "./ModalMotivoCancelamentoNfse";


const estados = [
    "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
    "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
    "RS", "RO", "RR", "SC", "SP", "SE", "TO"
];

const regimesTributarios = {
    simplesNacional: "Simples Nacional",
    simplesNacionalExcessoSublimite: "Simples Nacional — Excesso de sublimite",
    regimeNormal: "Regime Normal",
    simplesNacionalMEI: "MEI",
};

const corPrimaria = "#0b243d";
const botaoPrimario = { backgroundColor: corPrimaria, textTransform: "none", "&:hover": { backgroundColor: "#153d66" } };

const ABA_EMITIR = 0;
const ABA_CADASTRO = 1;
const ABA_NFSE = 2;
const ABA_SERVICOS = 3;
const ABA_DOCUMENTOS = 4;
const ABA_FICHA = 5;
const ABA_NOTAS = 6;

const formatarMoeda = (valor) => Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

// Ficha cadastral: capital vem como "1234.56" e datas de nascimento como "aaaa-mm-dd"
const formatarCapital = (valor) => (valor ? Number(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : "");
const formatarDataFicha = (data) => {
    const partes = String(data || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
    return partes ? `${partes[3]}/${partes[2]}/${partes[1]}` : (data || "");
};
const formatarPercentual = (valor) => `${Number(valor || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;

// Documentos que o cliente envia por sócio no painel dele (mesmos campos do model Documentos)
const TIPOS_DOCUMENTO = [
    { campo: "rgCnh", nome: "RG/CNH" },
    { campo: "tituloEleitor", nome: "Título de eleitor" },
    { campo: "comprovanteResidencia", nome: "Comprovante de residência" },
];

// O model grava false no nome do arquivo quando nada foi enviado
const arquivoEnviado = (nome) => Boolean(nome) && nome !== "false" && nome !== "0";

// O arquivo é salvo com a extensão original; HEIC não abre na maioria dos navegadores, então fica como "outro"
const tipoArquivo = (nome) => (/\.pdf$/i.test(nome) ? "pdf" : /\.(jpe?g|png|webp|gif)$/i.test(nome) ? "imagem" : "outro");

// Status gravados pelo back em PUT /aceitarDocumento e /rejeitarDocumento
const STATUS_DOCUMENTO_VALIDO = "Válido";
const STATUS_DOCUMENTO_REJEITADO = "Rejeitado";
const MAX_MOTIVO_REJEICAO = 255;
const MOTIVOS_REJEICAO_SUGERIDOS = [
    "Documento ilegível, envie novamente.",
    "Documento vencido.",
    "Documento incompleto (envie frente e verso).",
    "O arquivo não corresponde ao documento solicitado.",
];

const corStatusDocumento = (status) => ({ [STATUS_DOCUMENTO_VALIDO]: "success", "Em Análise": "info", [STATUS_DOCUMENTO_REJEITADO]: "error" }[status] || "default");

// Bloco padrão das seções: título, conteúdo e rodapé com as ações
function Secao({ titulo, descricao, acoes, children }) {
    return (
        <Card variant="outlined" sx={{ borderRadius: 2 }}>
            <Box sx={{ px: 2.5, py: 2 }}>
                <Typography sx={{ fontSize: 17, fontWeight: 600 }}>{titulo}</Typography>
                {descricao && <Typography variant="body2" color="text.secondary">{descricao}</Typography>}
            </Box>
            <Divider />
            <Box sx={{ p: 2.5 }}>{children}</Box>
            {acoes && (
                <>
                    <Divider />
                    <Box sx={{ px: 2.5, py: 1.5, display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2, backgroundColor: "#fafafa" }}>
                        {acoes}
                    </Box>
                </>
            )}
        </Card>
    );
}

// Subtítulo dentro de uma seção
function Subtitulo({ children }) {
    return (
        <Typography variant="overline" sx={{ display: "block", color: "text.secondary", fontWeight: 600, lineHeight: 2, mb: 1 }}>
            {children}
        </Typography>
    );
}

// Linha de campos em grid; empilha em telas pequenas
function Linha({ cols, children }) {
    return (
        <Box sx={{ display: "grid", gap: 2, alignItems: "start", gridTemplateColumns: { xs: "1fr", md: cols } }}>
            {children}
        </Box>
    );
}

// Senha gov.br do sócio: oculta por padrão, com botões de mostrar e copiar
function SenhaGov({ senha }) {
    const [visivel, setVisivel] = useState(false);
    const [copiada, setCopiada] = useState(false);

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(senha);
            setCopiada(true);
            setTimeout(() => setCopiada(false), 1500);
        } catch (err) {
            console.error("Não foi possível copiar a senha:", err);
        }
    };

    return (
        <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
            <Box component="span" sx={{ fontFamily: "monospace", letterSpacing: visivel ? 0.5 : 2 }}>
                {visivel ? senha : "••••••••"}
            </Box>
            <IconButton size="small" aria-label={visivel ? "Ocultar senha" : "Mostrar senha"} title={visivel ? "Ocultar senha" : "Mostrar senha"} onClick={() => setVisivel((v) => !v)}>
                {visivel ? <VisibilityOff sx={{ fontSize: 16 }} /> : <Visibility sx={{ fontSize: 16 }} />}
            </IconButton>
            <IconButton size="small" aria-label="Copiar senha" title={copiada ? "Copiada!" : "Copiar senha"} onClick={copiar}>
                <ContentCopyIcon sx={{ fontSize: 16, color: copiada ? "success.main" : undefined }} />
            </IconButton>
        </Box>
    );
}

// Grade de informações só para leitura (rótulo em cima, valor embaixo)
function Informacoes({ itens }) {
    return (
        <Box sx={{ display: "grid", columnGap: 3, rowGap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)" } }}>
            {itens.map((item) => (
                <Box key={item.label} sx={{ gridColumn: item.inteiro ? "1 / -1" : undefined, minWidth: 0 }}>
                    <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                    <Typography variant="body2" component="div" sx={{ fontWeight: 500, wordBreak: "break-word", color: item.valor ? "text.primary" : "text.disabled" }}>
                        {item.valor || "Não informado"}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}

function PerfilUsuario(props) {
    const { idUsuario } = useParams();

    const [aba, setAba] = useState(ABA_EMITIR);
    const [userInfo, setUserInfo] = useState({});
    const [certificado, setCertificado] = useState(null);
    const [empresa, setEmpresa] = useState(null);
    const [servicos, setServicos] = useState([]);
    const [notasEmitidas, setNotasEmitidas] = useState([]);
    const [hasTomador, setHasTomador] = useState(true);
    const [perfilLoading, setPerfilLoading] = useState(true);
    const [certificadoLoading, setCertificadoLoading] = useState(false);
    const [servicoLoading, setServicoLoading] = useState(false);
    const [empresaLoading, setEmpresaLoading] = useState(false);
    const [configuracaoLoading, setConfiguracaoLoading] = useState(false);
    const [notaLoading, setNotaLoading] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false);
    const [recarregarPerfil, setRecarregarPerfil] = useState(0); // força nova busca do perfil (ex.: status das notas)
    const [notaParaCancelar, setNotaParaCancelar] = useState(null); // { idNota, numero }
    const [baixandoPdf, setBaixandoPdf] = useState(null); // idNota em download
    const [limiteNotas, setLimiteNotas] = useState(0);
    const [qtdEmitidas, setQtdEmitidas] = useState(0);
    const token = localStorage.getItem('token');

    // Cadastro da empresa (formato da Contblack: salvar já cadastra/atualiza a empresa na Spedy)
    const [cnpjEmpresa, setCnpjEmpresa] = useState('');
    const [razaoSocialEmpresa, setRazaoSocialEmpresa] = useState('');
    const [nomeFantasiaEmpresa, setNomeFantasiaEmpresa] = useState('');
    const [inscricaoEstadualEmpresa, setInscricaoEstadualEmpresa] = useState('');
    const [inscricaoMunicipalEmpresa, setInscricaoMunicipalEmpresa] = useState('');
    const [emailEmpresa, setEmailEmpresa] = useState('');
    const [telefoneEmpresa, setTelefoneEmpresa] = useState('');
    const [celularEmpresa, setCelularEmpresa] = useState('');
    const [cepEmpresa, setCepEmpresa] = useState('');
    const [enderecoEmpresa, setEnderecoEmpresa] = useState('');
    const [numeroEmpresa, setNumeroEmpresa] = useState('');
    const [bairroEmpresa, setBairroEmpresa] = useState('');
    const [cidadeEmpresa, setCidadeEmpresa] = useState('');
    const [estadoEmpresa, setEstadoEmpresa] = useState('');
    const [codigoIbgeEmpresa, setCodigoIbgeEmpresa] = useState('');
    const [paisEmpresa, setPaisEmpresa] = useState('Brasil');
    const [taxRegimeEmpresa, setTaxRegimeEmpresa] = useState('');
    const [specialTaxRegimeEmpresa, setSpecialTaxRegimeEmpresa] = useState('');
    const [simplesNacionalTaxRegimeEmpresa, setSimplesNacionalTaxRegimeEmpresa] = useState('');
    const empresaSalva = !!empresa;
    const empresaNaSpedy = !!empresa?.idEmpresaSpedy;
    const empresaSimplesNacional = String(taxRegimeEmpresa).startsWith('simplesNacional');

    // Configurações de emissão (Emissor Nacional): série e próximo número da DPS
    const [serie, setSerie] = useState('');
    const [nextNumeroNota, setNextNumeroNota] = useState('');
    const [documentos, setDocumentos] = useState([]);
    const [fichaCadastral, setFichaCadastral] = useState(null);
    const [socios, setSocios] = useState([]);
    const [documentoAberto, setDocumentoAberto] = useState(null); // { idDocumento, campo, titulo, url, tipo, rotacao }
    const [rejeicao, setRejeicao] = useState(null); // { idDocumento, campo, titulo, motivo }
    const [avaliandoDocumento, setAvaliandoDocumento] = useState(null); // "idDocumento-campo" em andamento
    // Acumula os graus (sem % 360) para a animação sempre girar 90° no sentido clicado
    const girarDocumento = (graus) => setDocumentoAberto((doc) => ({ ...doc, rotacao: doc.rotacao + graus }));

    useEffect(() => {
        const getInfoUsuario = async () => {
            try {
                const responseUser = await axios.get(`${process.env.REACT_APP_API_URL}/getInfoPerfilUsuario/${idUsuario}`, {
                    headers: {
                        Authorization: localStorage.getItem('token')
                    }
                });

                if (responseUser.data.status !== 200) {
                    alert("Erro ao buscar informações do usuário.");
                    return;
                }
                const dados = responseUser.data.dados || {};
                setUserInfo(dados.usuario || {});
                setCertificado(dados.certificado || null);
                setEmpresa(dados.empresa || null);
                setServicos(dados.servicos || []);
                setNotasEmitidas(dados.notasEmitidasbyUsuario || []);
                setDocumentos(dados.documentos || []);
                setFichaCadastral(dados.fichaCadastral || null);
                setSocios(dados.socios || []);
                setLimiteNotas(dados.assinatura ? (dados.assinatura.plano?.qtdNfseMensalClarea ?? 0) : 0);
                setQtdEmitidas(dados.notasEmitidasbyClarea ?? 0);

                const empresaDados = dados.empresa || {};
                setCnpjEmpresa(empresaDados.cnpj ?? '');
                setRazaoSocialEmpresa(empresaDados.razaoSocial ?? '');
                setNomeFantasiaEmpresa(empresaDados.nomeFantasia ?? '');
                setInscricaoEstadualEmpresa(empresaDados.inscricaoEstadual ?? '');
                setInscricaoMunicipalEmpresa(empresaDados.inscricaoMunicipal ?? '');
                setEmailEmpresa(empresaDados.email ?? '');
                setTelefoneEmpresa(empresaDados.telefone ?? '');
                setCelularEmpresa(empresaDados.celular ?? '');
                setCepEmpresa(empresaDados.cep ?? '');
                setEnderecoEmpresa(empresaDados.endereco ?? '');
                setNumeroEmpresa(empresaDados.numero ?? '');
                setBairroEmpresa(empresaDados.bairro ?? '');
                setCidadeEmpresa(empresaDados.cidade ?? '');
                setEstadoEmpresa(String(empresaDados.estado ?? '').toUpperCase());
                setCodigoIbgeEmpresa(empresaDados.codigoIbge ?? '');
                setPaisEmpresa(empresaDados.pais || 'Brasil');
                setTaxRegimeEmpresa(empresaDados.taxRegime ?? '');
                setSpecialTaxRegimeEmpresa(empresaDados.specialTaxRegime ?? '');
                setSimplesNacionalTaxRegimeEmpresa(empresaDados.simplesNacionalTaxRegime ?? '');

                setSerie(empresaDados.series ?? '');
                setNextNumeroNota(empresaDados.nextNumber ?? '');
            } catch (err) {
                console.error("Erro ao buscar informações do usuário:", err);
                alert("Não foi possível carregar o perfil do usuário.");
            } finally {
                setPerfilLoading(false);
            }
        }

        getInfoUsuario();
    }, [idUsuario, certificadoLoading, servicoLoading, empresaLoading, configuracaoLoading, notaLoading, cancelLoading, recarregarPerfil]);

    const [isDragging, setIsDragging] = useState(false);
    const [file, setFile] = useState(null);
    const [senha, setSenha] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [codigo, setCodigo] = useState("");
    const [discriminacao, setDiscriminacao] = useState("");
    const [cnae, setCnae] = useState("");
    const [codigoNbs, setCodigoNbs] = useState("");
    const fileInputRef = useRef(null);

    // Funções de drag and drop
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => setIsDragging(false);

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const droppedFile = e.dataTransfer.files[0];
        validateFile(droppedFile);
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.target.files[0];
        validateFile(selectedFile);
    };

    const validateFile = (file) => {
        const nome = file?.name?.toLowerCase() || "";
        if (file && (nome.endsWith(".pfx") || nome.endsWith(".p12"))) {
            setFile(file);
        } else {
            alert("Por favor, selecione um arquivo .pfx ou .p12 válido.");
        }
    };

    // Controle da visibilidade da senha
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => event.preventDefault();

    const handleSaveUserInfo = () => {
        console.log("Salvar informações do usuário:", userInfo);
    }

    const handleSaveCertificado = async () => {
        if (!empresaNaSpedy) return alert("Salve os dados da empresa (cadastro na Spedy) antes de enviar o certificado.");
        if (!file) return alert("Selecione um arquivo de certificado.");
        if (!senha) return alert("Digite a senha do certificado.");

        const formData = new FormData();
        formData.append("arquivo", file);
        formData.append("senha", senha);
        formData.append("idUsuario", idUsuario);

        try {
            setCertificadoLoading(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/uploadCertificadoADM`, formData, {
                headers: {
                    Authorization: token,
                    "Content-Type": "multipart/form-data",
                },
            });
            if (data.status === 200) {
                const validadeCertificado = data.certificado?.validade;
                const validade = validadeCertificado ? ` Válido até ${new Date(validadeCertificado).toLocaleDateString("pt-BR")}.` : "";
                alert(`Certificado enviado com sucesso!${validade}`);
                setFile(null);
                setSenha("");
            } else {
                alert(`Falha ao enviar certificado: ${data.error || data.erro || "verifique o arquivo e a senha."}`);
            }
        } catch (err) {
            console.error(err);
            alert("Erro ao enviar o certificado. Tente novamente mais tarde.");
        } finally {
            setCertificadoLoading(false);
        }
    }

    const handleSaveServico = async () => {
        if (!codigo || !discriminacao) {
            return alert("Preencha todos os campos para adicionar um serviço.");
        }
        if (codigoNbs.replace(/\D/g, "").length !== 9) {
            return alert("Informe o código NBS do serviço (9 dígitos), obrigatório no Emissor Nacional.");
        }

        try {
            setServicoLoading(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/adicionarServicoADM`, {
                idUsuario: Number(idUsuario),
                codigo: codigo.trim(),
                discriminacao: discriminacao.trim(),
                cnae: cnae.trim() || undefined,
                codigoNbs: codigoNbs.replace(/\D/g, ""),
            }, {
                headers: {
                    Authorization: token,
                },
            });
            if (data.status === 200) {
                setCodigo('');
                setDiscriminacao('');
                setCnae('');
                setCodigoNbs('');
            } else {
                alert("Falha ao adicionar serviço: " + (data.mensagem || data.erro || "tente novamente."));
            }
        } catch (err) {
            console.error(err);
            alert("Erro ao adicionar serviço. Tente novamente mais tarde.");
        } finally {
            setServicoLoading(false);
        }

    }

    const handleDeleteServico = async (servico) => {
        if (!window.confirm(`Deseja remover o serviço ${servico.codigo} - ${servico.discriminacao} deste cliente?`)) return;

        try {
            setServicoLoading(true);
            const { data } = await axios.delete(`${process.env.REACT_APP_API_URL}/deletarServicoADM`, {
                headers: { Authorization: token },
                data: { idServico: servico.idServico },
            });
            if (data.status !== 200) {
                alert("Falha ao remover serviço: " + (data.mensagem || data.erro || "tente novamente."));
            } else if (servicoSelecionado?.idServico === servico.idServico) {
                setServicoSelecionado(null);
            }
        } catch (err) {
            console.error(err);
            alert("Erro ao remover serviço. Tente novamente mais tarde.");
        } finally {
            setServicoLoading(false);
        }
    }

    const [cpfCnpjTomador, setCpfCnpjTomador] = useState('');
    const [razaoSocialTomador, setRazaoSocialTomador] = useState('');
    const [emailTomador, setEmailTomador] = useState('');
    const [telefoneTomador, setTelefoneTomador] = useState('');
    const [cepTomador, setCepTomador] = useState('');
    const [enderecoTomador, setEnderecoTomador] = useState('');
    const [numeroTomador, setNumeroTomador] = useState('');
    const [estadoTomador, setEstadoTomador] = useState('');
    const [cidadeTomador, setCidadeTomador] = useState('');
    const [bairroTomador, setBairroTomador] = useState('');
    const [codigoIbgeTomador, setCodigoIbgeTomador] = useState('');
    const [servicoSelecionado, setServicoSelecionado] = useState(null);
    const [descricaoDoServico, setDescricaoDoServico] = useState('');
    const [valorServico, setValorServico] = useState('0');
    const hojeIso = () => new Date().toLocaleDateString("sv-SE"); // yyyy-mm-dd no fuso local
    const [dataCompetencia, setDataCompetencia] = useState(hojeIso);
    const [reterIr, setReterIr] = useState(false);
    const [valorIrRetido, setValorIrRetido] = useState('0');
    const [aliquotaSimples, setAliquotaSimples] = useState('');

    // "1.234,56" (ou o texto digitado no campo com MascaraValor) -> 1234.56
    const valorEmReais = (valor) => Number(MascaraValor(String(valor || "")).replace(/\./g, "").replace(",", ".")) || 0;
    const arredondar = (numero) => Math.round((Number.isFinite(numero) ? numero : 0) * 100) / 100;
    const percentual = (valor) => parseFloat(String(valor || "0").replace(",", ".")) || 0;

    const valorServicoNumero = arredondar(valorEmReais(valorServico));
    const valorIrRetidoNumero = reterIr ? arredondar(valorEmReais(valorIrRetido)) : 0;
    // Valor líquido = serviço - IR retido (mesma regra do backend)
    const valorLiquidoNumero = arredondar(valorServicoNumero - valorIrRetidoNumero);

    // Corpo no formato da Contblack (valores numéricos como number)
    const montarCorpoNota = () => ({
        idUsuario: Number(idUsuario),
        // Meio-dia no fuso de Brasília para a data não mudar de dia na conversão para UTC
        dataCompetencia: `${dataCompetencia}T12:00:00-03:00`,
        codigo: servicoSelecionado.codigo,
        descricaoDoServico: descricaoDoServico.trim(),
        total: {
            valorServico: valorServicoNumero,
            valorLiquido: valorLiquidoNumero,
            reterIr,
            valorIrRetido: valorIrRetidoNumero,
        },
        hasTomador,
        tomador: hasTomador ? {
            name: razaoSocialTomador.trim(),
            federalTaxNumber: TirarMascara(cpfCnpjTomador),
            email: emailTomador || null,
            phoneNumber: TirarMascara(telefoneTomador || '') || null,
            address: {
                street: enderecoTomador || null,
                district: bairroTomador || null,
                postalCode: TirarMascara(cepTomador || '') || null,
                number: numeroTomador || null,
                city: {
                    name: cidadeTomador || null,
                    state: estadoTomador ? estadoTomador.toLowerCase() : null,
                    code: codigoIbgeTomador ? Number(codigoIbgeTomador) : null,
                },
                country: "BRA",
            },
        } : null,
        approximateTaxes: { simplesNacionalRate: empresaSimplesNacional ? percentual(aliquotaSimples) : 0 },
    });

    const limparFormularioNota = () => {
        setCpfCnpjTomador('');
        setRazaoSocialTomador('');
        setEmailTomador('');
        setTelefoneTomador('');
        setCepTomador('');
        setEnderecoTomador('');
        setNumeroTomador('');
        setEstadoTomador('');
        setCidadeTomador('');
        setBairroTomador('');
        setCodigoIbgeTomador('');
        setDataCompetencia(hojeIso());
        setReterIr(false);
        setValorIrRetido('0');
        setServicoSelecionado(null);
        setDescricaoDoServico('');
        setValorServico('0');
    };

    const handleEmitirNota = async () => {
        if (notaLoading) return;
        if (bloqueioEmissao) {
            alert(bloqueioEmissao);
            return;
        }
        if (!servicoSelecionado) {
            alert('Por favor, selecione um serviço.');
            return;
        }
        if (!servicoSelecionado.codigoNbs) {
            alert('Este serviço não tem código NBS, obrigatório no Emissor Nacional. Cadastre o NBS do serviço antes de emitir.');
            return;
        }
        if (!descricaoDoServico.trim()) {
            alert('Por favor, informe a descrição do serviço.');
            return;
        }
        if (valorServicoNumero <= 0) {
            alert('Por favor, informe um valor de serviço válido.');
            return;
        }
        if (!dataCompetencia) {
            alert('Informe a data de competência.');
            return;
        }
        if (reterIr && (valorIrRetidoNumero <= 0 || valorIrRetidoNumero > valorServicoNumero)) {
            alert('Informe um valor de IR retido maior que zero e menor que o valor do serviço.');
            return;
        }
        if (hasTomador) {
            const documento = TirarMascara(cpfCnpjTomador);
            if (!razaoSocialTomador.trim() || (documento.length !== 11 && documento.length !== 14)) {
                alert('Por favor, informe um CPF/CNPJ válido e a razão social do tomador.');
                return;
            }
        }

        setNotaLoading(true);
        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/emitirNotaServicoADM`, montarCorpoNota(), {
                headers: {
                    Authorization: localStorage.getItem('token'),
                    'Content-Type': 'application/json'
                }
            });

            if (data.status === 200) {
                // A emissão é assíncrona: o status muda para Emitida/Rejeitada quando a prefeitura responder
                alert('Nota enviada para emissão. Acompanhe o status na aba "Notas emitidas".');
                limparFormularioNota();
            } else {
                alert('Erro ao emitir nota fiscal: ' + (data.error || data.erro || data.mensagem || data.message || 'verifique os dados e tente novamente.'));
            }
        } catch (err) {
            console.error(err);
            const resposta = err.response?.data;
            alert('Erro ao emitir nota fiscal: ' + (resposta?.error || resposta?.erro || resposta?.mensagem || resposta?.message || 'tente novamente mais tarde.'));
        } finally {
            setNotaLoading(false);
        }
    }

    const handleSaveCompany = async () => {
        const erros = [];
        if (TirarMascara(cnpjEmpresa || '').length !== 14) erros.push("CNPJ inválido.");
        if (!String(razaoSocialEmpresa || '').trim()) erros.push("Razão Social é obrigatória.");
        if (!String(nomeFantasiaEmpresa || '').trim()) erros.push("Nome Fantasia é obrigatório.");
        if (!taxRegimeEmpresa) erros.push("Regime Tributário é obrigatório.");
        if (TirarMascara(cepEmpresa || '').length !== 8) erros.push("CEP é obrigatório e deve ter 8 dígitos.");
        if (![enderecoEmpresa, numeroEmpresa, bairroEmpresa, cidadeEmpresa].every((v) => String(v || '').trim())) erros.push("Endereço, número, bairro e cidade são obrigatórios.");
        if (!estados.includes(estadoEmpresa)) erros.push("Selecione o estado.");
        if (erros.length) return alert(erros.join("\n"));

        setEmpresaLoading(true);
        try {
            // Código IBGE do município (usado pela Spedy para localizar a prefeitura)
            let codigoIbge = codigoIbgeEmpresa;
            try {
                const { data: viaCep } = await axios.get(`https://viacep.com.br/ws/${TirarMascara(cepEmpresa)}/json/`);
                if (viaCep?.ibge) codigoIbge = viaCep.ibge;
            } catch (err) {
                console.warn("ViaCEP indisponível:", err);
            }
            if (!codigoIbge) {
                alert("Não foi possível identificar o código IBGE do município pelo CEP. Verifique o CEP informado.");
                return;
            }

            // Formato da Contblack: o backend cadastra/atualiza a empresa na Spedy e no banco
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/salvarDadosEmpresaADM`, {
                idUsuario: Number(idUsuario),
                nomeFantasiaEmpresa: nomeFantasiaEmpresa.trim(),
                razaoSocialEmpresa: razaoSocialEmpresa.trim(),
                cnpjEmpresa: TirarMascara(cnpjEmpresa),
                inscricaoEstadualEmpresa,
                inscricaoMunicipalEmpresa,
                emailEmpresa,
                telefoneEmpresa: TirarMascara(telefoneEmpresa || ''),
                celularEmpresa: TirarMascara(celularEmpresa || ''),
                endereco: {
                    enderecoEmpresa,
                    bairroEmpresa,
                    cepEmpresa: TirarMascara(cepEmpresa),
                    numeroEmpresa,
                },
                cidade: {
                    codigoIbge: String(codigoIbge),
                    nome: cidadeEmpresa,
                    state: estadoEmpresa.toLowerCase(),
                },
                pais: { nome: paisEmpresa || 'Brasil' },
                taxRegime: taxRegimeEmpresa,
                specialTaxRegime: specialTaxRegimeEmpresa,
                simplesNacionalTaxRegime: empresaSimplesNacional ? simplesNacionalTaxRegimeEmpresa : '',
            }, { headers: { Authorization: token } });

            if (data.status === 200) {
                const proximoPasso = empresa?.series ? "" : "\n\nAgora salve as configurações de emissão (série e próximo número) na aba \"NFS-e e certificado\".";
                alert((data.mensagem || "Dados da empresa salvos com sucesso!") + proximoPasso);
            } else {
                alert("Falha ao salvar os dados da empresa: " + (data.erro || data.error || data.mensagem || "verifique os dados."));
            }
        } catch (err) {
            console.error(err);
            alert("Erro ao salvar os dados da empresa. Tente novamente mais tarde.");
        } finally {
            setEmpresaLoading(false);
        }
    }

    // Configuração da NFS-e no Emissor Nacional (série e próximo número da DPS)
    const handleSaveConfiguracoes = async () => {
        if (!empresaNaSpedy) return alert("Salve os dados da empresa (cadastro na Spedy) antes de configurar a emissão.");
        if (!/^\d{1,5}$/.test(String(serie || ''))) return alert("Série inválida: use apenas números (até 5 dígitos), ex.: 1.");
        if (!/^[1-9]\d{0,14}$/.test(String(nextNumeroNota || ''))) return alert("Próximo número inválido: use um número inteiro maior que zero.");

        setConfiguracaoLoading(true);
        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/salvarConfiguracoesEmpresaADM`, {
                idUsuario: Number(idUsuario),
                serie: String(serie),
                nextNumeroNota: Number(nextNumeroNota),
            }, { headers: { Authorization: token } });

            if (data.status === 200) {
                const certificadoPendente = certificado ? "" : "\n\nAgora envie o certificado digital A1 da empresa.";
                alert((data.mensagem || "Configurações de emissão salvas com sucesso!") + certificadoPendente);
            } else {
                alert("Falha ao salvar as configurações de emissão: " + (data.erro || data.error || data.mensagem || "verifique os dados."));
            }
        } catch (err) {
            console.error(err);
            alert("Erro ao salvar as configurações de emissão. Tente novamente mais tarde.");
        } finally {
            setConfiguracaoLoading(false);
        }
    }


    const handleCnpj = async (e) => {
        setCnpjEmpresa(TirarMascara(e.target.value));
        if (e.target.value.length !== 18) return;

        try {
            const { data: resposta } = await axios.get(`${process.env.REACT_APP_API_URL}/buscarCnpj/${TirarMascara(e.target.value)}`, {
                headers: { Authorization: token },
            });
            if (resposta.status !== 200) return alert(resposta.erro || "CNPJ não encontrado.");

            const dados = resposta.data;
            if (dados.situacao && dados.situacao !== "Ativa") alert(`Atenção: a situação cadastral deste CNPJ na Receita é "${dados.situacao}".`);
            setRazaoSocialEmpresa(dados.razao_social || '');
            setNomeFantasiaEmpresa(dados.nome || '');
            setCepEmpresa(dados.endereco.cep || '');
            setEnderecoEmpresa(dados.endereco.logradouro || '');
            setNumeroEmpresa(dados.endereco.numero || '');
            setEstadoEmpresa(String(dados.endereco.uf || '').toUpperCase());
            setCidadeEmpresa(dados.endereco.municipio || '');
            setBairroEmpresa(dados.endereco.bairro || '');
            setTelefoneEmpresa(dados.telefone || '');
            setCelularEmpresa(dados.celular || '');
            setEmailEmpresa(dados.email || '');
            if (dados.endereco.codigoIbge) setCodigoIbgeEmpresa(dados.endereco.codigoIbge);
        } catch (err) {
            console.error("Erro ao buscar CNPJ:", err);
            alert("Não foi possível buscar os dados do CNPJ. Tente novamente mais tarde.");
        }
    }

    // CEP do tomador: preenche o endereço e o código IBGE do município (enviado à Spedy)
    const handleCepTomador = async (e) => {
        const cep = TirarMascara(e.target.value).slice(0, 8);
        setCepTomador(cep);
        if (cep.length !== 8) return;

        try {
            const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
            if (data?.erro) return alert("Não encontramos o endereço deste CEP. Verifique se o CEP é válido.");
            if (data.logradouro) setEnderecoTomador(data.logradouro);
            if (data.bairro) setBairroTomador(data.bairro);
            setCidadeTomador(data.localidade || '');
            setEstadoTomador(String(data.uf || '').toUpperCase());
            setCodigoIbgeTomador(data.ibge || '');
        } catch (err) {
            console.warn("ViaCEP indisponível:", err);
        }
    };

    const handleCnpjTomador = async (e) => {
        let value = e.target.value;
        if (!value) {
            setCpfCnpjTomador('');
            return;
        }

        const somenteNumeros = value.replace(/\D/g, "");

        // CPF até 11 dígitos | CNPJ até 14 dígitos
        if (somenteNumeros.length <= 11) {
            setCpfCnpjTomador(MascaraCpf(value));
            return;
        }

        // Caso seja CNPJ
        setCpfCnpjTomador(MascaraCnpj(value));

        // Só faz a busca quando o CNPJ estiver completo (14 dígitos)
        if (somenteNumeros.length !== 14) return;

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/buscarCnpj/${somenteNumeros}`,
                { headers: { Authorization: token } }
            );

            if (response.data?.status === 200) {
                const dados = response.data.data;

                setRazaoSocialTomador(dados.razao_social || "");
                setCepTomador(dados.endereco?.cep || "");
                setEnderecoTomador(dados.endereco?.logradouro || "");
                setNumeroTomador(dados.endereco?.numero || "");
                setEstadoTomador(String(dados.endereco?.uf || "").toUpperCase());
                setCidadeTomador(dados.endereco?.municipio || "");
                setBairroTomador(dados.endereco?.bairro || "");
                setCodigoIbgeTomador(dados.endereco?.codigoIbge || "");
                setEmailTomador(dados.email || "");
                setTelefoneTomador(dados.telefone || "");
            } else {
                alert(response.data?.erro || "CNPJ não encontrado.");
            }
        } catch (error) {
            console.error("Erro ao buscar CNPJ:", error);
            alert("Não foi possível buscar os dados do CNPJ. Tente novamente mais tarde.");
        }
    };

    // Aceita ou rejeita um dos arquivos do sócio. Atualiza só o estado local (recarregar o perfil
    // descartaria o que estiver sendo digitado nos outros formulários).
    const avaliarDocumento = async (idDocumento, campo, aprovar, motivo = "") => {
        setAvaliandoDocumento(`${idDocumento}-${campo}`);
        try {
            const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/${aprovar ? "aceitarDocumento" : "rejeitarDocumento"}`, {
                idDocumento,
                tipoDocumento: campo,
                motivo: aprovar ? undefined : motivo.trim(),
            }, { headers: { Authorization: token } });

            if (data.status !== 200) {
                alert(data.message || data.erro || "Não foi possível avaliar o documento.");
                return false;
            }
            setDocumentos((docs) => docs.map((doc) => doc.idDocumento === idDocumento
                ? {
                    ...doc,
                    [`${campo}Status`]: aprovar ? STATUS_DOCUMENTO_VALIDO : STATUS_DOCUMENTO_REJEITADO,
                    [`${campo}MotivoRejeicao`]: aprovar ? null : motivo.trim(),
                }
                : doc));
            return true;
        } catch (err) {
            console.error("Erro ao avaliar documento:", err);
            alert("Erro ao avaliar o documento. Tente novamente mais tarde.");
            return false;
        } finally {
            setAvaliandoDocumento(null);
        }
    };

    const handleAprovarDocumento = async (idDocumento, campo) => {
        if (await avaliarDocumento(idDocumento, campo, true)) setDocumentoAberto(null);
    };

    const handleConfirmarRejeicao = async () => {
        if (!rejeicao.motivo.trim()) return alert("Informe o motivo da rejeição.");
        if (await avaliarDocumento(rejeicao.idDocumento, rejeicao.campo, false, rejeicao.motivo)) {
            setRejeicao(null);
            setDocumentoAberto(null);
        }
    };

    // Botões de aprovar/rejeitar, usados no cartão e na visualização do documento
    const acoesDocumento = ({ idDocumento, campo, titulo, status }) => {
        const avaliando = avaliandoDocumento === `${idDocumento}-${campo}`;
        return (
            <>
                <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    sx={{ textTransform: "none" }}
                    disabled={avaliando || status === STATUS_DOCUMENTO_REJEITADO}
                    onClick={() => setRejeicao({ idDocumento, campo, titulo, motivo: "" })}
                >
                    Rejeitar
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    color="success"
                    sx={{ textTransform: "none" }}
                    disabled={status === STATUS_DOCUMENTO_VALIDO}
                    loading={avaliando && !rejeicao}
                    onClick={() => handleAprovarDocumento(idDocumento, campo)}
                >
                    Aprovar
                </Button>
            </>
        );
    };

    // Cancelamento da NFS-e: o backend responde com HTTP status = status do corpo ({ status, mensagem } | { status, erro })
    const handleCancelarNota = async (motivo) => {
        if (!notaParaCancelar) return false;
        setCancelLoading(true);
        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/cancelar/nfse`, {
                idNota: notaParaCancelar.idNota,
                reason: motivo,
            }, { headers: { Authorization: token } });

            if (data?.status && data.status !== 200) {
                alert("Erro ao cancelar a nota: " + (data.erro || data.error || data.mensagem || "a nota não pôde ser cancelada."));
                return false;
            }
            alert(data?.mensagem || "Solicitação de cancelamento enviada.");
            setNotaParaCancelar(null);
            return true;
        } catch (err) {
            console.error("Erro ao cancelar NFS-e:", err);
            const resposta = err.response?.data;
            alert("Erro ao cancelar a nota: " + (resposta?.erro || resposta?.error || resposta?.mensagem || "tente novamente mais tarde."));
            return false;
        } finally {
            setCancelLoading(false);
        }
    };

    // PDF da NFS-e. Em erro o backend devolve JSON { status, erro }, que chega como blob
    const handleDownloadPdf = async (nota) => {
        setBaixandoPdf(nota.idNota);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/download/nfse/pdf`, {
                idNota: nota.idNota,
            }, {
                headers: { Authorization: token },
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
            const link = document.createElement("a");
            link.href = url;
            link.download = `nfse_${numeroNota(nota) || nota.idNota}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Erro ao baixar NFS-e:", err);
            let mensagem = "";
            try {
                const texto = await err.response?.data?.text?.();
                const json = texto ? JSON.parse(texto) : null;
                mensagem = json?.erro || json?.error || json?.mensagem || "";
            } catch {
                // resposta sem JSON
            }
            alert("Erro ao baixar o PDF da nota: " + (mensagem || "tente novamente mais tarde."));
        } finally {
            setBaixandoPdf(null);
        }
    };

    // Certificado: a Clarea grava arquivoNome e validade
    const certificadoVencido = !!certificado?.validade && new Date(certificado.validade) < new Date();
    const semLimite = limiteNotas === -1;
    const limiteAtingido = !semLimite && qtdEmitidas >= limiteNotas;
    const textoLimite = `${qtdEmitidas}/${semLimite ? "ilimitado" : limiteNotas}`;

    // Motivo que impede a emissão (fluxo: empresa na Spedy -> configurações -> certificado -> serviços)
    const bloqueioEmissao =
        perfilLoading ? "Carregando o perfil do cliente..." :
            !empresaSalva ? 'Cadastre a empresa do cliente na aba "Dados cadastrais" antes de emitir notas.' :
                !empresa.emissaoConfigurada ? 'A empresa não está cadastrada na Spedy. Salve novamente os dados da empresa na aba "Dados cadastrais".' :
                    !certificado ? 'Envie o certificado digital do cliente na aba "NFS-e e certificado" antes de emitir notas.' :
                        certificadoVencido ? 'O certificado digital do cliente está vencido. Envie o certificado renovado antes de emitir notas.' :
                            limiteAtingido ? 'O limite mensal de notas emitidas pela equipe para este cliente foi atingido.' :
                                null;
    // Não bloqueia (o backend não exige), mas a Spedy precisa da série/número para emitir no Emissor Nacional
    const configuracaoPendente = empresa?.emissaoConfigurada && (!empresa.series || !empresa.nextNumber);

    // Pendências exibidas no resumo e nas abas
    const cadastroPendente = !empresaSalva || !empresa?.emissaoConfigurada;
    const nfsePendente = !empresa?.emissaoConfigurada || !empresa?.series || !empresa?.nextNumber || !certificado || certificadoVencido;
    const servicosPendentes = servicos.length === 0 || servicos.some((s) => !s.codigoNbs);
    const notasRejeitadas = notasEmitidas.filter((n) => ["REJECTED", "DENIED", "ERRO"].includes(n.status)).length;
    const iconePendente = <ErrorOutlineIcon fontSize="small" sx={{ color: "#ed6c02" }} />;

    const itensDocumentos = documentos.flatMap((doc) => TIPOS_DOCUMENTO.map((tipo) => ({ ...tipo, status: doc[`${tipo.campo}Status`] })));
    const docsEmAnalise = itensDocumentos.filter((item) => item.status === "Em Análise").length;
    const documentosAprovados = itensDocumentos.length > 0 && itensDocumentos.every((item) => item.status === STATUS_DOCUMENTO_VALIDO);
    const documentosPendentes = !documentosAprovados;

    // A ficha está completa quando existe, tem sócios e as participações somam 100%
    const somaParticipacoes = Math.round(socios.reduce((soma, s) => soma + (Number(s.percentual) || 0), 0) * 100) / 100;
    const fichaPendente = !fichaCadastral || socios.length === 0 || somaParticipacoes !== 100;
    const documentosDoSocio = (idSocio) => documentos.find((doc) => doc.idSocio === idSocio);

    const statusDocumentos = documentos.length === 0
        ? { label: "Nenhum documento enviado", color: "default" }
        : docsEmAnalise
            ? { label: `${docsEmAnalise} documento(s) em análise`, color: "info" }
            : documentosAprovados
                ? { label: "Documentos aprovados", color: "success" }
                : { label: "Documentos pendentes", color: "warning" };

    const statusSpedy = !empresaSalva
        ? { label: "Empresa não cadastrada", color: "warning" }
        : !empresa.emissaoConfigurada
            ? { label: "Não cadastrada na Spedy", color: "warning" }
            : !empresa.series || !empresa.nextNumber
                ? { label: "Configuração de emissão pendente", color: "warning" }
                : { label: "Emissão configurada", color: "success" };

    const statusCertificado = !certificado
        ? { label: "Sem certificado", color: "error" }
        : certificadoVencido
            ? { label: `Certificado vencido em ${new Date(certificado.validade).toLocaleDateString("pt-BR")}`, color: "error" }
            : {
                label: certificado.validade
                    ? `Certificado até ${new Date(certificado.validade).toLocaleDateString("pt-BR")}`
                    : "Certificado enviado",
                color: "success",
            };

    const nomeUsuario = userInfo?.nome || "Usuário";
    const iniciais = nomeUsuario.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("");

    return (
        <div>
            <Header />
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", pb: 6 }}>
                <Box sx={{ width: "90%", maxWidth: 1280, mt: 2.5 }}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit" href="/Dashboard">
                            Dashboard
                        </Link>
                        <Link underline="hover" color="inherit" href="/EmitirNota">
                            Emitir Nota
                        </Link>
                        <Typography sx={{ color: 'text.primary' }}>Perfil Usuário</Typography>
                    </Breadcrumbs>

                    {/* Resumo do cliente */}
                    <Card variant="outlined" sx={{ borderRadius: 2, mt: 2 }}>
                        <Box sx={{ p: 2.5, display: "flex", flexWrap: "wrap", alignItems: "center", gap: 3 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 260 }}>
                                <Avatar sx={{ bgcolor: corPrimaria, width: 52, height: 52 }}>{iniciais}</Avatar>
                                <Box>
                                    <Typography sx={{ fontSize: 20, fontWeight: 600, lineHeight: 1.3 }}>{nomeUsuario}</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {[userInfo?.email, userInfo?.telefone && MascaraTelefone(userInfo.telefone)].filter(Boolean).join(" · ") || `ID ${idUsuario}`}
                                    </Typography>
                                </Box>
                            </Box>

                            <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", md: "block" } }} />

                            <Box sx={{ flex: 1, minWidth: 240 }}>
                                <Typography variant="caption" color="text.secondary">Empresa</Typography>
                                <Typography sx={{ fontWeight: 500 }}>{razaoSocialEmpresa || "Não cadastrada"}</Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {[cnpjEmpresa && MascaraCnpj(cnpjEmpresa), regimesTributarios[taxRegimeEmpresa], cidadeEmpresa && `${cidadeEmpresa}/${estadoEmpresa}`].filter(Boolean).join(" · ")}
                                </Typography>
                            </Box>

                            <Box sx={{ display: "flex", gap: 1 }}>
                                <Button variant="outlined" size="small" startIcon={<NotasIcon />} sx={{ textTransform: "none" }} onClick={() => setAba(ABA_NOTAS)}>
                                    Notas emitidas ({notasEmitidas.length})
                                </Button>
                            </Box>
                        </Box>
                        <Divider />
                        <Box sx={{ px: 2.5, py: 1.5, display: "flex", flexWrap: "wrap", gap: 1, backgroundColor: "#fafafa" }}>
                            <Chip size="small" variant="outlined" color={statusSpedy.color} label={statusSpedy.label} onClick={() => setAba(ABA_NFSE)} />
                            <Chip size="small" variant="outlined" color={statusCertificado.color} label={statusCertificado.label} onClick={() => setAba(ABA_NFSE)} />
                            <Chip size="small" variant="outlined" color={servicosPendentes ? "warning" : "default"} label={`${servicos.length} serviço(s) cadastrado(s)`} onClick={() => setAba(ABA_SERVICOS)} />
                            <Chip size="small" variant="outlined" color={statusDocumentos.color} label={statusDocumentos.label} onClick={() => setAba(ABA_DOCUMENTOS)} />
                            <Chip size="small" variant="outlined" color={limiteAtingido ? "error" : "default"} label={`NFS-e pela equipe (mês): ${textoLimite}`} onClick={() => setAba(ABA_EMITIR)} />
                            {notasRejeitadas > 0 && (
                                <Chip size="small" variant="outlined" color="error" label={`${notasRejeitadas} nota(s) rejeitada(s) ou com erro`} onClick={() => setAba(ABA_NOTAS)} />
                            )}
                        </Box>
                    </Card>

                    {/* Navegação entre as áreas do perfil */}
                    <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 3 }}>
                        <Tabs
                            value={aba}
                            onChange={(e, novaAba) => setAba(novaAba)}
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{ "& .MuiTab-root": { textTransform: "none", minHeight: 48 }, "& .Mui-selected": { color: `${corPrimaria} !important` }, "& .MuiTabs-indicator": { backgroundColor: corPrimaria } }}
                        >
                            <Tab value={ABA_EMITIR} label="Emitir nota" />
                            <Tab value={ABA_CADASTRO} label="Dados cadastrais" icon={cadastroPendente ? iconePendente : undefined} iconPosition="end" />
                            <Tab value={ABA_FICHA} label="Ficha cadastral" icon={fichaPendente ? iconePendente : undefined} iconPosition="end" />
                            <Tab value={ABA_DOCUMENTOS} label="Documentos" icon={documentosPendentes ? iconePendente : undefined} iconPosition="end" />
                            <Tab value={ABA_NFSE} label="NFS-e e certificado" icon={nfsePendente ? iconePendente : undefined} iconPosition="end" />
                            <Tab value={ABA_SERVICOS} label="Serviços" icon={servicosPendentes ? iconePendente : undefined} iconPosition="end" />
                            <Tab value={ABA_NOTAS} label={`Notas emitidas (${notasEmitidas.length})`} />
                        </Tabs>
                    </Box>

                    <Stack spacing={3} sx={{ mt: 3 }}>
                        {aba === ABA_EMITIR && (
                            <>
                                {bloqueioEmissao && !perfilLoading && (
                                    <Alert
                                        severity="warning"
                                        action={limiteAtingido && empresa?.emissaoConfigurada && certificado && !certificadoVencido ? undefined : (
                                            <Button color="inherit" size="small" onClick={() => setAba(!empresa?.emissaoConfigurada ? ABA_CADASTRO : ABA_NFSE)}>
                                                Configurar
                                            </Button>
                                        )}
                                    >
                                        {bloqueioEmissao}
                                    </Alert>
                                )}
                                {!bloqueioEmissao && configuracaoPendente && (
                                    <Alert severity="warning" action={<Button color="inherit" size="small" onClick={() => setAba(ABA_NFSE)}>Configurar</Button>}>
                                        As configurações de emissão (série e próximo número da DPS) ainda não foram salvas.
                                    </Alert>
                                )}
                                <Secao
                                    titulo="Emitir Nota Fiscal (Serviço)"
                                    descricao={`Notas emitidas pela equipe neste mês: ${textoLimite}`}
                                    acoes={
                                        <Button variant="contained" disabled={!!bloqueioEmissao} size="small" sx={botaoPrimario} loading={notaLoading} onClick={handleEmitirNota}>
                                            Emitir Nota Fiscal
                                        </Button>
                                    }
                                >
                                    <Stack spacing={3}>
                                        <Box>
                                            <Subtitulo>Prestador</Subtitulo>
                                            <Typography>
                                                {razaoSocialEmpresa || "Empresa não cadastrada"}
                                                {cnpjEmpresa && <Typography component="span" color="text.secondary"> · {MascaraCnpj(cnpjEmpresa)}</Typography>}
                                            </Typography>
                                        </Box>

                                        <Divider />

                                        <Box>
                                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <Subtitulo>Tomador</Subtitulo>
                                                <FormControlLabel control={<Checkbox size="small" checked={hasTomador} onChange={(e) => setHasTomador(e.target.checked)} />} label="Nota possui tomador?" sx={{ mr: 0 }} />
                                            </Box>
                                            {hasTomador ? (
                                                <Stack spacing={2}>
                                                    <Linha cols="1fr 1fr">
                                                        <TextField size='small' fullWidth label="CPF ou CNPJ" required variant="outlined" value={cpfCnpjTomador} onChange={e => handleCnpjTomador(e)} />
                                                        <TextField size='small' fullWidth label="Razão Social" required variant="outlined" value={razaoSocialTomador} onChange={e => setRazaoSocialTomador(e.target.value)} />
                                                    </Linha>
                                                    <Linha cols="1fr 1fr">
                                                        <TextField size='small' fullWidth label="E-mail" variant="outlined" value={emailTomador} onChange={e => setEmailTomador(e.target.value)} />
                                                        <TextField size='small' fullWidth label="Telefone" variant="outlined" value={MascaraTelefone(telefoneTomador)} onChange={e => setTelefoneTomador(TirarMascara(e.target.value))} inputProps={{ maxLength: 15 }} />
                                                    </Linha>
                                                    <Linha cols="160px 1fr 100px">
                                                        <TextField size='small' fullWidth label="CEP" variant="outlined" value={MascaraCep(cepTomador)} onChange={handleCepTomador} inputProps={{ maxLength: 9 }} helperText="Preenche o endereço" />
                                                        <TextField size='small' fullWidth label="Endereço" variant="outlined" value={enderecoTomador} onChange={e => setEnderecoTomador(e.target.value)} />
                                                        <TextField size='small' fullWidth label="Nº" variant="outlined" value={numeroTomador} onChange={e => setNumeroTomador(e.target.value)} />
                                                    </Linha>
                                                    <Linha cols="120px 1fr 1fr">
                                                        <FormControl fullWidth size='small'>
                                                            <InputLabel id="estado-select-label">Estado</InputLabel>
                                                            <Select
                                                                labelId="estado-select-label"
                                                                id="estado-select"
                                                                label="Estado"
                                                                value={estadoTomador}
                                                                onChange={e => setEstadoTomador(e.target.value)}
                                                            >
                                                                {estados.map((uf) => (
                                                                    <MenuItem key={uf} value={uf}>{uf}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                        <TextField size='small' fullWidth label="Cidade" variant="outlined" value={cidadeTomador} onChange={e => { setCidadeTomador(e.target.value); setCodigoIbgeTomador(''); }} />
                                                        <TextField size='small' fullWidth label="Bairro" variant="outlined" value={bairroTomador} onChange={e => setBairroTomador(e.target.value)} />
                                                    </Linha>
                                                </Stack>
                                            ) : (
                                                <Typography variant="body2" sx={{ color: "#ed6c02" }}>Nota fiscal de serviço sem tomador.</Typography>
                                            )}
                                        </Box>

                                        <Divider />

                                        <Box>
                                            <Subtitulo>Serviço</Subtitulo>
                                            <Stack spacing={2}>
                                                <Autocomplete
                                                    size="small"
                                                    fullWidth
                                                    disablePortal
                                                    options={servicos}
                                                    getOptionLabel={(option) =>
                                                        `${option.codigo} - ${option.discriminacao} - ${option.codigoNbs ? `NBS ${option.codigoNbs}` : 'sem NBS'}`
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.idServico === value.idServico}
                                                    value={servicoSelecionado}
                                                    onChange={(event, newValue) => {
                                                        setServicoSelecionado(newValue);
                                                        // A descrição da nota começa com a discriminação do serviço e pode ser editada
                                                        if (newValue) setDescricaoDoServico(newValue.discriminacao || '');
                                                    }}
                                                    renderOption={(props, option) => (
                                                        <Box
                                                            component="li"
                                                            {...props}
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "flex-start",
                                                                paddingY: 0.5,
                                                            }}
                                                        >
                                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                                código: {option.codigo} — cnae: {option.cnae ? option.cnae : 'Não definido'} — NBS: {option.codigoNbs || <Box component="span" sx={{ color: "#ed6c02" }}>não cadastrado</Box>}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary">
                                                                {option.discriminacao}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Serviço" placeholder='Selecione os serviço que foi prestado' variant="outlined" />
                                                    )}
                                                />
                                                {servicoSelecionado && !servicoSelecionado.codigoNbs && (
                                                    <Alert severity="error" action={<Button color="inherit" size="small" onClick={() => setAba(ABA_SERVICOS)}>Serviços</Button>}>
                                                        Este serviço não tem código NBS, obrigatório no Emissor Nacional. Cadastre o serviço com o NBS antes de emitir.
                                                    </Alert>
                                                )}
                                                <Linha cols="1fr 3fr">
                                                    <TextField size="small" fullWidth type="date" label="Data de competência" value={dataCompetencia} onChange={e => setDataCompetencia(e.target.value)} InputLabelProps={{ shrink: true }} variant="outlined" />
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        multiline
                                                        minRows={2}
                                                        label="Descrição do serviço"
                                                        placeholder="Texto que aparece na nota"
                                                        value={descricaoDoServico}
                                                        onChange={e => setDescricaoDoServico(e.target.value)}
                                                        variant="outlined"
                                                    />
                                                </Linha>
                                            </Stack>
                                        </Box>

                                        <Divider />

                                        <Box>
                                            <Subtitulo>Valores e retenções</Subtitulo>
                                            <Stack spacing={2}>
                                                <Linha cols="1fr 1fr">
                                                    <TextField size='small' fullWidth label="Valor do Serviço" variant="outlined" value={MascaraValor(valorServico)} onChange={e => setValorServico(e.target.value)} />
                                                    <TextField size='small' fullWidth label="Valor líquido" variant="outlined" disabled value={formatarMoeda(valorLiquidoNumero)} helperText="Valor do serviço menos o IR retido" />
                                                </Linha>
                                                <Linha cols="auto 1fr 1.5fr">
                                                    <FormControlLabel sx={{ mr: 0 }} control={<Checkbox size="small" checked={reterIr} onChange={e => setReterIr(e.target.checked)} />} label="Reter IR" />
                                                    <TextField size='small' fullWidth label="Valor do IR retido" variant="outlined" disabled={!reterIr} value={MascaraValor(valorIrRetido)} onChange={e => setValorIrRetido(e.target.value)} />
                                                    <TextField size='small' fullWidth label="Alíquota do Simples Nacional (%)" variant="outlined" disabled={!empresaSimplesNacional} value={aliquotaSimples} onChange={e => setAliquotaSimples(e.target.value)} helperText={empresaSimplesNacional ? "Alíquota efetiva do DAS (tributos aproximados)" : "Só para empresas do Simples Nacional"} />
                                                </Linha>
                                            </Stack>
                                        </Box>
                                    </Stack>
                                </Secao>
                            </>
                        )}

                        {aba === ABA_CADASTRO && (
                            <>
                                <Secao
                                    titulo="Informações do usuário"
                                    acoes={<Button variant="contained" disabled size="small" sx={botaoPrimario} onClick={handleSaveUserInfo}>Salvar alterações</Button>}
                                >
                                    <Linha cols="1fr 1fr 1fr 1fr">
                                        <TextField label="Nome" fullWidth size="small" value={userInfo?.nome || ''} onChange={(e) => setUserInfo({ ...userInfo, nome: e.target.value })} />
                                        <TextField label="Email" fullWidth size="small" value={userInfo?.email || ''} onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })} />
                                        <TextField label="CPF" fullWidth size="small" value={MascaraCpf(userInfo?.cpf)} onChange={e => setUserInfo({ ...userInfo, cpf: e.target.value.replaceAll(/\D/g, '') })} inputProps={{ maxLength: 14 }} />
                                        <TextField label="Telefone" fullWidth size="small" value={MascaraTelefone(userInfo?.telefone)} onChange={e => setUserInfo({ ...userInfo, telefone: e.target.value.replaceAll(/\D/g, '') })} inputProps={{ maxLength: 14 }} />
                                    </Linha>
                                </Secao>

                                <Secao
                                    titulo="Informações da Empresa"
                                    descricao="Digite o CNPJ completo para preencher os dados automaticamente pela Receita. Ao salvar, a empresa é cadastrada/atualizada na Spedy."
                                    acoes={<Button variant="contained" size="small" sx={botaoPrimario} onClick={handleSaveCompany} loading={empresaLoading}>Salvar alterações</Button>}
                                >
                                    <Stack spacing={3}>
                                        {!perfilLoading && (
                                            !empresaSalva ? (
                                                <Alert severity="info">Empresa ainda não cadastrada. Preencha os dados e salve para cadastrá-la na Spedy.</Alert>
                                            ) : !empresa.emissaoConfigurada ? (
                                                <Alert severity="warning">A empresa ainda não está cadastrada na Spedy. Salve os dados novamente para concluir o cadastro.</Alert>
                                            ) : (
                                                <Alert severity="success">Empresa cadastrada na Spedy.</Alert>
                                            )
                                        )}
                                        <Box>
                                            <Subtitulo>Identificação</Subtitulo>
                                            <Stack spacing={2}>
                                                <Linha cols="1fr 1fr 1fr">
                                                    <TextField label="CNPJ" fullWidth size="small" value={MascaraCnpj(cnpjEmpresa)} onChange={(e) => handleCnpj(e)} inputProps={{ maxLength: 18 }} />
                                                    <TextField label="Inscrição Estadual" fullWidth size="small" value={(inscricaoEstadualEmpresa)} onChange={e => setInscricaoEstadualEmpresa(TirarMascara(e.target.value))} helperText="Opcional" />
                                                    <TextField label="Inscrição Municipal" fullWidth size="small" value={(inscricaoMunicipalEmpresa)} onChange={e => setInscricaoMunicipalEmpresa(TirarMascara(e.target.value))} helperText="Opcional" />
                                                </Linha>
                                                <Linha cols="1fr 1fr">
                                                    <TextField label="Razão Social" fullWidth size="small" value={razaoSocialEmpresa} onChange={e => setRazaoSocialEmpresa(e.target.value)} inputProps={{ maxLength: 80 }} />
                                                    <TextField label="Nome Fantasia" fullWidth size="small" value={nomeFantasiaEmpresa} onChange={e => setNomeFantasiaEmpresa(e.target.value)} inputProps={{ maxLength: 80 }} />
                                                </Linha>
                                            </Stack>
                                        </Box>

                                        <Box>
                                            <Subtitulo>Tributação</Subtitulo>
                                            <Stack spacing={2}>
                                                <Linha cols="1fr 1fr 1fr">
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>Regime Tributário</InputLabel>
                                                        <Select value={taxRegimeEmpresa} label="Regime Tributário" onChange={e => setTaxRegimeEmpresa(e.target.value)}>
                                                            <MenuItem value="simplesNacional">Simples Nacional</MenuItem>
                                                            <MenuItem value="simplesNacionalExcessoSublimite">Simples Nacional — Excesso de sublimite de receita bruta</MenuItem>
                                                            <MenuItem value="regimeNormal">Regime Normal (Lucro Presumido ou Lucro Real)</MenuItem>
                                                            <MenuItem value="simplesNacionalMEI">MEI (Microempreendedor individual)</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>Regime Tributário Especial</InputLabel>
                                                        <Select value={specialTaxRegimeEmpresa} label="Regime Tributário Especial" onChange={e => setSpecialTaxRegimeEmpresa(e.target.value)}>
                                                            <MenuItem value="">Não informado</MenuItem>
                                                            <MenuItem value="noSpecialRegime">Sem regime especial</MenuItem>
                                                            <MenuItem value="municipalMicroenterprise">Microempresa Municipal</MenuItem>
                                                            <MenuItem value="estimate">Estimativa</MenuItem>
                                                            <MenuItem value="societyOfProfessionals">Sociedade de Profissionais</MenuItem>
                                                            <MenuItem value="cooperative">Cooperativa</MenuItem>
                                                            <MenuItem value="individualMicroenterprise">Microempresário Individual (MEI)</MenuItem>
                                                            <MenuItem value="microenterpriseAndSmallBusiness">Microempresa ou Empresa de Pequeno Porte (ME/EPP)</MenuItem>
                                                            <MenuItem value="others">Outros</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl fullWidth size="small" disabled={!empresaSimplesNacional}>
                                                        <InputLabel>Recolhimento no Simples Nacional</InputLabel>
                                                        <Select value={empresaSimplesNacional ? simplesNacionalTaxRegimeEmpresa : ""} label="Recolhimento no Simples Nacional" onChange={e => setSimplesNacionalTaxRegimeEmpresa(e.target.value)}>
                                                            <MenuItem value="">Não informado</MenuItem>
                                                            <MenuItem value="federalAndMunicipalBySimplesNacional">Regime de apuração dos tributos federais e municipal pelo Simples Nacional</MenuItem>
                                                            <MenuItem value="federalBySimplesAndIssqnByNfse">Regime de apuração dos tributos federais pelo Simples Nacional e o ISSQN pela NFS-e conforme legislação municipal</MenuItem>
                                                            <MenuItem value="federalAndMunicipalByNfse">Regime de apuração dos tributos federais e municipal pela NFS-e conforme legislações federal e municipal</MenuItem>
                                                        </Select>
                                                        {!empresaSimplesNacional && <FormHelperText>Só para empresas do Simples Nacional</FormHelperText>}
                                                    </FormControl>
                                                </Linha>
                                            </Stack>
                                        </Box>

                                        <Box>
                                            <Subtitulo>Endereço e contato</Subtitulo>
                                            <Stack spacing={2}>
                                                <Linha cols="140px 2fr 100px">
                                                    <TextField label="CEP" fullWidth size="small" value={MascaraCep(cepEmpresa)} onChange={e => setCepEmpresa(TirarMascara(e.target.value))} inputProps={{ maxLength: 9 }} />
                                                    <TextField label="Endereço" fullWidth size="small" value={enderecoEmpresa} onChange={e => setEnderecoEmpresa(e.target.value)} inputProps={{ maxLength: 100 }} />
                                                    <TextField label="Nº" fullWidth size="small" value={numeroEmpresa || ''} onChange={e => setNumeroEmpresa(e.target.value)} inputProps={{ maxLength: 10 }} />
                                                </Linha>
                                                <Linha cols="1fr 1fr 120px">
                                                    <TextField label="Bairro" fullWidth size="small" value={bairroEmpresa} onChange={e => setBairroEmpresa(e.target.value)} inputProps={{ maxLength: 100 }} />
                                                    <TextField label="Cidade" fullWidth size="small" value={cidadeEmpresa} onChange={e => setCidadeEmpresa(e.target.value)} />
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel>Estado</InputLabel>
                                                        <Select value={estadoEmpresa} label="Estado" onChange={e => setEstadoEmpresa(e.target.value)}>
                                                            {estados.map((uf) => <MenuItem key={uf} value={uf}>{uf}</MenuItem>)}
                                                        </Select>
                                                    </FormControl>
                                                </Linha>
                                                <Linha cols="2fr 1fr 1fr">
                                                    <TextField label="E-mail" fullWidth size="small" value={emailEmpresa} onChange={e => setEmailEmpresa(e.target.value)} inputProps={{ maxLength: 80 }} helperText="Opcional" />
                                                    <TextField label="Telefone" fullWidth size="small" value={MascaraTelefone(telefoneEmpresa)} onChange={e => setTelefoneEmpresa(TirarMascara(e.target.value))} inputProps={{ maxLength: 15 }} helperText="Opcional" />
                                                    <TextField label="Celular" fullWidth size="small" value={MascaraTelefone(celularEmpresa)} onChange={e => setCelularEmpresa(TirarMascara(e.target.value))} inputProps={{ maxLength: 15 }} helperText="Opcional" />
                                                </Linha>
                                            </Stack>
                                        </Box>
                                    </Stack>
                                </Secao>
                            </>
                        )}

                        {aba === ABA_FICHA && (
                            !fichaCadastral ? (
                                <Alert severity="info">
                                    O cliente ainda não preencheu a ficha cadastral no painel dele.
                                </Alert>
                            ) : (
                                <>
                                    <Secao
                                        titulo="Dados da empresa"
                                        descricao={`Informados pelo cliente na ficha cadastral${fichaCadastral.updatedAt ? ` · atualizada em ${new Date(fichaCadastral.updatedAt).toLocaleDateString("pt-BR")}` : ""}.`}
                                    >
                                        <Stack spacing={3}>
                                            <Informacoes itens={[
                                                { label: "Razão social", valor: fichaCadastral.razaoSocial },
                                                { label: "Nome fantasia", valor: fichaCadastral.nomeFantasia },
                                                { label: "CNPJ", valor: fichaCadastral.cnpj && MascaraCnpj(fichaCadastral.cnpj) },
                                                { label: "Capital social", valor: formatarCapital(fichaCadastral.capitalSocial) },
                                                { label: "Endereço", valor: fichaCadastral.enderecoEmpresa, inteiro: true },
                                            ]} />
                                            <Box>
                                                <Typography variant="caption" color="text.secondary">Atividades da empresa</Typography>
                                                {Array.isArray(fichaCadastral.atividades) && fichaCadastral.atividades.length > 0 ? (
                                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 0.5 }}>
                                                        {fichaCadastral.atividades.map((atividade) => (
                                                            <Chip key={atividade} label={atividade} size="small" variant="outlined" />
                                                        ))}
                                                    </Box>
                                                ) : (
                                                    <Typography variant="body2" color="text.disabled">Não informado</Typography>
                                                )}
                                            </Box>
                                            {/* A ficha é o que o cliente informou; o cadastro da empresa é o usado na emissão */}
                                            {empresaSalva && fichaCadastral.cnpj && TirarMascara(fichaCadastral.cnpj) !== TirarMascara(cnpjEmpresa) && (
                                                <Alert severity="warning">
                                                    O CNPJ da ficha ({MascaraCnpj(fichaCadastral.cnpj)}) é diferente do CNPJ do cadastro da empresa ({MascaraCnpj(cnpjEmpresa)}).
                                                </Alert>
                                            )}
                                        </Stack>
                                    </Secao>

                                    <Secao
                                        titulo={`Sócios (${socios.length})`}
                                        descricao={socios.length ? `Participações somam ${formatarPercentual(somaParticipacoes)}.` : undefined}
                                    >
                                        {socios.length === 0 ? (
                                            <Typography variant="body2" color="text.secondary">Nenhum sócio cadastrado na ficha.</Typography>
                                        ) : (
                                            <Stack spacing={1.5}>
                                                {somaParticipacoes !== 100 && (
                                                    <Alert severity="warning">
                                                        As participações dos sócios somam {formatarPercentual(somaParticipacoes)}; o total deve ser 100%.
                                                    </Alert>
                                                )}
                                                {socios.map((socio, indice) => {
                                                    const docs = documentosDoSocio(socio.idSocio);
                                                    const validos = TIPOS_DOCUMENTO.filter((t) => docs?.[`${t.campo}Status`] === STATUS_DOCUMENTO_VALIDO).length;
                                                    const casado = socio.estadoCivil === "Casado(a)";
                                                    return (
                                                        <Accordion
                                                            key={socio.idSocio}
                                                            defaultExpanded={indice === 0}
                                                            disableGutters
                                                            variant="outlined"
                                                            sx={{ borderRadius: "8px !important", "&::before": { display: "none" } }}
                                                        >
                                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap", flex: 1, mr: 1 }}>
                                                                    <Avatar sx={{ width: 36, height: 36, fontSize: 14, bgcolor: corPrimaria }}>
                                                                        {String(socio.nome || "?").trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("")}
                                                                    </Avatar>
                                                                    <Box sx={{ flex: 1, minWidth: 160 }}>
                                                                        <Typography sx={{ fontWeight: 500 }}>{socio.nome || "Sócio sem nome"}</Typography>
                                                                        <Typography variant="caption" color="text.secondary">
                                                                            {socio.cpf ? `CPF ${MascaraCpf(socio.cpf)}` : "CPF não informado"}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Chip size="small" variant="outlined" label={`${formatarPercentual(socio.percentual)} de participação`} />
                                                                    <Chip
                                                                        size="small"
                                                                        variant="outlined"
                                                                        color={validos === TIPOS_DOCUMENTO.length ? "success" : docs ? "info" : "default"}
                                                                        label={docs ? `Documentos ${validos}/${TIPOS_DOCUMENTO.length} válidos` : "Sem documentos"}
                                                                        onClick={(e) => { e.stopPropagation(); setAba(ABA_DOCUMENTOS); }}
                                                                    />
                                                                </Box>
                                                            </AccordionSummary>
                                                            <AccordionDetails sx={{ borderTop: 1, borderColor: "divider", pt: 2 }}>
                                                                <Stack spacing={2.5}>
                                                                    <Box>
                                                                        <Subtitulo>Dados pessoais</Subtitulo>
                                                                        <Informacoes itens={[
                                                                            { label: "Data de nascimento", valor: formatarDataFicha(socio.dataNascimento) },
                                                                            { label: "Naturalidade", valor: socio.naturalidade },
                                                                            { label: "Estado civil", valor: socio.estadoCivil },
                                                                            ...(casado ? [
                                                                                { label: "Regime de bens", valor: socio.regimeBens },
                                                                                { label: "CPF do cônjuge", valor: socio.cpfConjugue && MascaraCpf(socio.cpfConjugue) },
                                                                            ] : []),
                                                                        ]} />
                                                                    </Box>
                                                                    <Box>
                                                                        <Subtitulo>Documentos</Subtitulo>
                                                                        <Informacoes itens={[
                                                                            { label: "RG", valor: [socio.rg, socio.orgaoRg].filter(Boolean).join(" · ") },
                                                                            { label: "Título de eleitor", valor: socio.tituloEleitor },
                                                                            { label: "PIS/NIS/NIT", valor: socio.pisNisNit },
                                                                            { label: "CNH", valor: [socio.cnh, socio.estadoEmissaoCnh].filter(Boolean).join(" · ") },
                                                                            { label: "Senha gov.br", valor: socio.senhaGov ? <SenhaGov senha={socio.senhaGov} /> : "" },
                                                                        ]} />
                                                                    </Box>
                                                                    <Box>
                                                                        <Subtitulo>Contato</Subtitulo>
                                                                        <Informacoes itens={[
                                                                            { label: "E-mail", valor: socio.email },
                                                                            { label: "Telefone", valor: socio.telefone && MascaraTelefone(socio.telefone) },
                                                                            { label: "Endereço", valor: socio.endereco, inteiro: true },
                                                                        ]} />
                                                                    </Box>
                                                                </Stack>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    );
                                                })}
                                            </Stack>
                                        )}
                                    </Secao>
                                </>
                            )
                        )}

                        {aba === ABA_DOCUMENTOS && (
                            <Secao
                                titulo="Documentos dos sócios"
                                descricao="Documentos enviados pelo cliente no painel dele."
                            >
                                {documentos.length === 0 ? (
                                    <Typography variant="body2" color="text.secondary">
                                        Nenhum documento enviado pelo cliente.
                                    </Typography>
                                ) : (
                                    <Stack spacing={3}>
                                        {documentos.map((doc, indice) => (
                                            <Box key={doc.idDocumento}>
                                                {indice > 0 && <Divider sx={{ mb: 3 }} />}
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 1 }}>
                                                    <Subtitulo>{doc.nomeSocio || `Sócio #${doc.idSocio}`}</Subtitulo>
                                                    {doc.updatedAt && (
                                                        <Typography variant="caption" color="text.secondary">
                                                            Atualizado em {new Date(doc.updatedAt).toLocaleString("pt-BR")}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Linha cols="1fr 1fr 1fr">
                                                    {TIPOS_DOCUMENTO.map((tipo) => {
                                                        const nomeArquivo = doc[`${tipo.campo}FileName`];
                                                        const enviado = arquivoEnviado(nomeArquivo);
                                                        const status = doc[`${tipo.campo}Status`];
                                                        const motivo = doc[`${tipo.campo}MotivoRejeicao`];
                                                        const url = doc[`${tipo.campo}Url`];
                                                        const formato = tipoArquivo(nomeArquivo);
                                                        const titulo = `${tipo.nome} — ${doc.nomeSocio || `Sócio #${doc.idSocio}`}`;
                                                        const abrir = () => setDocumentoAberto({ idDocumento: doc.idDocumento, campo: tipo.campo, titulo, url, tipo: formato, rotacao: 0 });
                                                        return (
                                                            <Box key={tipo.campo} sx={{ border: 1, borderColor: "divider", borderRadius: 2, p: 2, height: "100%", boxSizing: "border-box" }}>
                                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                                                    <Typography sx={{ fontWeight: 500 }}>{tipo.nome}</Typography>
                                                                    <Chip
                                                                        size="small"
                                                                        variant="outlined"
                                                                        color={enviado ? corStatusDocumento(status) : "default"}
                                                                        label={enviado ? (status || "Sem status") : "Não enviado"}
                                                                    />
                                                                </Box>
                                                                {/* Miniatura: clique abre a visualização */}
                                                                <Box
                                                                    onClick={url ? abrir : undefined}
                                                                    sx={{
                                                                        mt: 1.5,
                                                                        height: 140,
                                                                        borderRadius: 1,
                                                                        overflow: "hidden",
                                                                        backgroundColor: "#f5f5f5",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: 0.5,
                                                                        cursor: url ? "pointer" : "default",
                                                                        "&:hover": url ? { outline: `2px solid ${corPrimaria}` } : undefined,
                                                                    }}
                                                                >
                                                                    {!url ? (
                                                                        <Typography variant="body2" color="text.disabled">{enviado ? "Arquivo indisponível" : "Nenhum arquivo"}</Typography>
                                                                    ) : formato === "imagem" ? (
                                                                        <img src={url} alt={tipo.nome} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                                    ) : (
                                                                        <>
                                                                            {formato === "pdf" ? <PictureAsPdfIcon sx={{ fontSize: 40, color: "#d32f2f" }} /> : <ArquivoIcon sx={{ fontSize: 40, color: corPrimaria }} />}
                                                                            <Typography variant="body2" color="text.secondary">Clique para visualizar</Typography>
                                                                        </>
                                                                    )}
                                                                </Box>
                                                                {motivo && (
                                                                    <Typography variant="body2" sx={{ mt: 1, color: "#d32f2f" }}>
                                                                        Motivo da rejeição: {motivo}
                                                                    </Typography>
                                                                )}
                                                                {enviado && (
                                                                    <Box sx={{ mt: 1.5, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                                                                        {acoesDocumento({ idDocumento: doc.idDocumento, campo: tipo.campo, titulo, status })}
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        );
                                                    })}
                                                </Linha>
                                            </Box>
                                        ))}
                                    </Stack>
                                )}
                            </Secao>
                        )}

                        {aba === ABA_NFSE && (
                            <>
                                <Secao
                                    titulo="Configurações de emissão"
                                    descricao="Emissor Nacional: série e número da próxima DPS/NFS-e da empresa na Spedy."
                                    acoes={
                                        <Button variant="contained" disabled={!empresaNaSpedy} size="small" sx={botaoPrimario} onClick={handleSaveConfiguracoes} loading={configuracaoLoading}>
                                            Salvar configurações
                                        </Button>
                                    }
                                >
                                    <Stack spacing={2}>
                                        {!empresaNaSpedy ? (
                                            <Alert severity="error" action={<Button color="inherit" size="small" onClick={() => setAba(ABA_CADASTRO)}>Cadastrar empresa</Button>}>
                                                Salve os dados da empresa (cadastro na Spedy) antes de configurar a emissão.
                                            </Alert>
                                        ) : empresa?.series && empresa?.nextNumber ? (
                                            <Alert severity="success">
                                                Emissão configurada: série <strong>{empresa.series}</strong>, próximo número <strong>{empresa.nextNumber}</strong>.
                                            </Alert>
                                        ) : (
                                            <Alert severity="warning">
                                                Informe a série e o próximo número da DPS e salve as configurações.
                                            </Alert>
                                        )}
                                        <Linha cols="1fr 1fr">
                                            <TextField label="Série" fullWidth size="small" disabled={!empresaNaSpedy} value={serie || ''} onChange={e => setSerie(e.target.value.replace(/\D/g, "").slice(0, 5))} helperText="Apenas números, ex.: 1" />
                                            <TextField label="Próximo número da DPS/NFS-e" fullWidth size="small" disabled={!empresaNaSpedy} value={nextNumeroNota || ''} onChange={e => setNextNumeroNota(e.target.value.replace(/\D/g, "").slice(0, 15))} helperText="Número inteiro maior que zero" />
                                        </Linha>
                                    </Stack>
                                </Secao>

                                <Secao
                                    titulo="Certificado Digital"
                                    acoes={<Button variant="contained" disabled={!empresaNaSpedy} size="small" sx={botaoPrimario} onClick={handleSaveCertificado} loading={certificadoLoading}>Enviar certificado</Button>}
                                >
                                    <Stack spacing={3}>
                                        {!empresaNaSpedy ? (
                                            <Alert severity="error">Salve os dados da empresa (cadastro na Spedy) antes de enviar o certificado.</Alert>
                                        ) : certificado && certificadoVencido ? (
                                            <Alert severity="error">
                                                Certificado vencido: <strong>{certificado.arquivoNome || "certificado A1"}</strong> — venceu em {new Date(certificado.validade).toLocaleDateString("pt-BR")}.
                                                <Typography variant="body2" sx={{ mt: 0.5 }}>
                                                    Envie o certificado renovado abaixo para voltar a emitir notas.
                                                </Typography>
                                            </Alert>
                                        ) : certificado ? (
                                            <Alert severity="success" icon={<VerifiedUserIcon />}>
                                                Certificado ativo: <strong>{certificado.arquivoNome || "certificado A1"}</strong>
                                                {certificado.validade && ` — válido até ${new Date(certificado.validade).toLocaleDateString("pt-BR")}`}
                                                <Typography variant="body2" sx={{ mt: 0.5 }}>
                                                    A empresa possui um certificado digital na Spedy. Para atualizá-lo, envie um novo arquivo abaixo.
                                                </Typography>
                                            </Alert>
                                        ) : (
                                            <Alert severity="error">
                                                Nenhum certificado enviado. Envie o certificado A1 da empresa (obrigatório no Emissor Nacional).
                                            </Alert>
                                        )}

                                        <Linha cols="1fr 1fr">
                                            {/* Upload do certificado */}
                                            <Box
                                                onDragOver={handleDragOver}
                                                onDragLeave={handleDragLeave}
                                                onDrop={handleDrop}
                                                onClick={() => fileInputRef.current.click()}
                                                sx={{
                                                    border: "2px dashed #ccc",
                                                    borderRadius: 2,
                                                    p: 3,
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                    borderColor: isDragging ? "#ffc845" : "#ccc",
                                                    backgroundColor: isDragging ? "#fffbe6" : "transparent",
                                                    transition: "all 0.2s ease",
                                                }}
                                            >
                                                {file ? (
                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                        {file.name}
                                                    </Typography>
                                                ) : (
                                                    <>
                                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                            Arraste e solte o certificado (.pfx ou .p12)
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ my: 1 }}>
                                                            ou
                                                        </Typography>
                                                        <Button variant="outlined" size="small" sx={{ textTransform: "none" }} onClick={() => fileInputRef.current.click()}>
                                                            Procurar Arquivo
                                                        </Button>
                                                    </>
                                                )}
                                                <input
                                                    type="file"
                                                    accept=".pfx,.p12"
                                                    ref={fileInputRef}
                                                    onChange={handleFileSelect}
                                                    style={{ display: "none" }}
                                                />
                                            </Box>

                                            <Stack spacing={2}>
                                                {/* Senha do certificado */}
                                                <FormControl fullWidth size="small" variant="outlined" autoComplete="off">
                                                    <InputLabel htmlFor="outlined-adornment-password">Senha do Certificado</InputLabel>
                                                    <OutlinedInput
                                                        id="outlined-adornment-password"
                                                        name="fakepassword"
                                                        value={senha}
                                                        onChange={(e) => setSenha(e.target.value)}
                                                        placeholder="Digite a senha do seu certificado"
                                                        type={showPassword ? "text" : "password"}
                                                        autoComplete="new-password"
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    onClick={handleClickShowPassword}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    edge="end"
                                                                    aria-label="toggle password visibility"
                                                                >
                                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                        label="Senha do Certificado"
                                                    />
                                                    <FormHelperText>
                                                        A senha é necessária para validar o arquivo do certificado.
                                                    </FormHelperText>
                                                </FormControl>
                                                {/* E-mail */}
                                                <FormControl fullWidth size="small" variant="outlined">
                                                    <InputLabel>E-mail para notificação</InputLabel>
                                                    <OutlinedInput
                                                        value={userInfo?.email || userInfo?.Email || ''}
                                                        disabled
                                                        placeholder="Digite seu e-mail"
                                                        type="email"
                                                        autoComplete="off"
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <EmailIcon />
                                                            </InputAdornment>
                                                        }
                                                        label="E-mail para notificação"
                                                    />
                                                    <FormHelperText>
                                                        Enviaremos notificações para este e-mail quando o certificado estiver próximo do vencimento.
                                                    </FormHelperText>
                                                </FormControl>
                                            </Stack>
                                        </Linha>
                                    </Stack>
                                </Secao>
                            </>
                        )}

                        {aba === ABA_SERVICOS && (
                            <Secao
                                titulo="Serviços do usuário"
                                descricao="Serviços disponíveis para seleção na emissão da nota."
                                acoes={<Button variant="contained" size="small" sx={botaoPrimario} onClick={handleSaveServico} loading={servicoLoading}>Adicionar Serviço</Button>}
                            >
                                <Stack spacing={3}>
                                    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: "#fafafa" }}>
                                                    <TableCell><strong>ID</strong></TableCell>
                                                    <TableCell><strong>Código</strong></TableCell>
                                                    <TableCell><strong>Discriminação</strong></TableCell>
                                                    <TableCell><strong>CNAE</strong></TableCell>
                                                    <TableCell><strong>NBS</strong></TableCell>
                                                    <TableCell><strong>Ação</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {servicos.length > 0 ? (
                                                    servicos.map((servico) => (
                                                        <TableRow key={servico.idServico}>
                                                            <TableCell>{servico.idServico}</TableCell>
                                                            <TableCell>{servico.codigo}</TableCell>
                                                            <TableCell>{servico.discriminacao}</TableCell>
                                                            <TableCell>{servico.cnae}</TableCell>
                                                            <TableCell>
                                                                {servico.codigoNbs || <Chip size="small" color="warning" variant="outlined" label="Sem NBS" />}
                                                            </TableCell>
                                                            <TableCell>
                                                                <Tooltip title="Remover serviço">
                                                                    <span>
                                                                        <IconButton size="small" color="error" aria-label="Remover serviço" disabled={servicoLoading} onClick={() => handleDeleteServico(servico)}>
                                                                            <DeleteOutlineIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </span>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={6} align="center">
                                                            Nenhum serviço encontrado.
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <Box>
                                        <Subtitulo>Novo serviço</Subtitulo>
                                        <Stack spacing={2}>
                                            <Linha cols="1fr 1fr 1fr">
                                                <TextField label="Código" fullWidth value={codigo} onChange={(e) => setCodigo(e.target.value)} variant="outlined" size='small' />
                                                <TextField label="CNAE" fullWidth value={cnae} onChange={(e) => setCnae(e.target.value)} variant="outlined" size='small' />
                                                <TextField label="Código NBS" fullWidth value={codigoNbs} onChange={(e) => setCodigoNbs(e.target.value)} variant="outlined" size='small' helperText="Obrigatório no Emissor Nacional" />
                                            </Linha>
                                            <TextField
                                                label="Discriminação"
                                                placeholder="Descreva o serviço aqui"
                                                rows={3}
                                                multiline
                                                fullWidth
                                                size="small"
                                                value={discriminacao}
                                                onChange={(e) => setDiscriminacao(e.target.value)}
                                            />
                                        </Stack>
                                    </Box>
                                </Stack>
                            </Secao>
                        )}

                        {aba === ABA_NOTAS && (
                            <Secao
                                titulo="Notas fiscais emitidas"
                                descricao="Todas as NFS-e do cliente. O status é atualizado quando a prefeitura responde."
                                acoes={
                                    <Button variant="outlined" size="small" startIcon={<RefreshIcon />} sx={{ textTransform: "none" }} onClick={() => setRecarregarPerfil((n) => n + 1)}>
                                        Atualizar lista
                                    </Button>
                                }
                            >
                                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
                                    <Table size="small" sx={{ minWidth: 860 }}>
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: "#fafafa" }}>
                                                <TableCell><strong>ID</strong></TableCell>
                                                <TableCell><strong>Nº nota</strong></TableCell>
                                                <TableCell><strong>Status</strong></TableCell>
                                                <TableCell><strong>Tomador</strong></TableCell>
                                                <TableCell><strong>Valor</strong></TableCell>
                                                <TableCell><strong>Emitida por</strong></TableCell>
                                                <TableCell><strong>Data de emissão</strong></TableCell>
                                                <TableCell align="right"><strong>Ações</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {notasEmitidas.length > 0 ? (
                                                notasEmitidas.map((nota) => {
                                                    const status = statusNota(nota.status);
                                                    const motivo = mensagemNota(nota);
                                                    const mostrarMotivo = ["REJECTED", "DENIED", "ERRO"].includes(nota.status) && motivo;
                                                    return (
                                                        <TableRow key={nota.idNota}>
                                                            <TableCell>{nota.idNota}</TableCell>
                                                            <TableCell>{numeroNota(nota) || "—"}</TableCell>
                                                            <TableCell sx={{ maxWidth: 280 }}>
                                                                <Chip size="small" variant="outlined" color={status.color} label={status.label} />
                                                                {mostrarMotivo && (
                                                                    <Typography variant="caption" component="div" sx={{ mt: 0.5, color: "#d32f2f", wordBreak: "break-word" }}>
                                                                        {motivo}
                                                                    </Typography>
                                                                )}
                                                            </TableCell>
                                                            <TableCell>{tomadorNota(nota) || "—"}</TableCell>
                                                            <TableCell sx={{ whiteSpace: "nowrap" }}>{formatarMoeda(nota.valor)}</TableCell>
                                                            <TableCell>{Number(nota.emitidaPor) === Number(nota.idUsuario) ? "Cliente" : "Equipe Clarea"}</TableCell>
                                                            <TableCell sx={{ whiteSpace: "nowrap" }}>{nota.dataEmissao ? new Date(nota.dataEmissao).toLocaleString("pt-BR") : "—"}</TableCell>
                                                            <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                                                                <Tooltip title={podeBaixarPdf(nota.status) ? "Baixar PDF" : "PDF disponível após a autorização da nota"}>
                                                                    <span>
                                                                        <IconButton size="small" aria-label="Baixar PDF" disabled={!podeBaixarPdf(nota.status) || baixandoPdf === nota.idNota} onClick={() => handleDownloadPdf(nota)}>
                                                                            <DownloadIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </span>
                                                                </Tooltip>
                                                                <Tooltip title={podeCancelar(nota.status) ? "Cancelar nota" : "Somente notas emitidas podem ser canceladas"}>
                                                                    <span>
                                                                        <IconButton size="small" color="error" aria-label="Cancelar nota" disabled={!podeCancelar(nota.status)} onClick={() => setNotaParaCancelar({ idNota: nota.idNota, numero: numeroNota(nota) })}>
                                                                            <CancelOutlinedIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </span>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center">
                                                        Nenhuma nota emitida para este cliente.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Secao>
                        )}
                    </Stack>
                </Box>
            </Box>

            {/* Motivo do cancelamento da NFS-e */}
            <ModalMotivoCancelamentoNfse
                open={!!notaParaCancelar}
                nota={notaParaCancelar}
                loading={cancelLoading}
                onClose={() => setNotaParaCancelar(null)}
                onConfirmar={handleCancelarNota}
            />

            {/* Visualização do documento do sócio */}
            <Dialog open={!!documentoAberto} onClose={() => setDocumentoAberto(null)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ fontSize: 17, fontWeight: 600 }}>{documentoAberto?.titulo}</DialogTitle>
                <DialogContent dividers sx={{ p: 0, backgroundColor: "#f5f5f5", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                    {documentoAberto?.tipo === "imagem" ? (
                        <Box sx={{ height: "75vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <img
                                src={documentoAberto.url}
                                alt={documentoAberto.titulo}
                                style={{
                                    objectFit: "contain",
                                    transform: `rotate(${documentoAberto.rotacao}deg)`,
                                    transition: "transform 0.2s ease",
                                    // Deitada, a altura da imagem passa a ocupar a largura do diálogo (e vice-versa)
                                    ...(Math.abs(documentoAberto.rotacao) % 180 === 0
                                        ? { maxWidth: "100%", maxHeight: "75vh" }
                                        : { maxWidth: "75vh", maxHeight: "min(900px, calc(100vw - 64px))" }),
                                }}
                            />
                        </Box>
                    ) : documentoAberto?.tipo === "pdf" ? (
                        <iframe src={documentoAberto.url} title={documentoAberto.titulo} style={{ width: "100%", height: "75vh", border: 0 }} />
                    ) : (
                        <Typography variant="body2" color="text.secondary" sx={{ p: 4 }}>
                            Este formato não pode ser exibido aqui. Use "Abrir em nova aba" para baixar o arquivo.
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    {documentoAberto?.tipo === "imagem" && (
                        <Box sx={{ mr: "auto", display: "flex", gap: 0.5 }}>
                            <IconButton size="small" aria-label="Girar para a esquerda" title="Girar para a esquerda" onClick={() => girarDocumento(-90)}>
                                <RotateLeftIcon />
                            </IconButton>
                            <IconButton size="small" aria-label="Girar para a direita" title="Girar para a direita" onClick={() => girarDocumento(90)}>
                                <RotateRightIcon />
                            </IconButton>
                        </Box>
                    )}
                    <Button href={documentoAberto?.url} target="_blank" rel="noopener noreferrer" sx={{ textTransform: "none" }}>
                        Abrir em nova aba
                    </Button>
                    <Button size="small" sx={{ textTransform: "none" }} onClick={() => setDocumentoAberto(null)}>
                        Fechar
                    </Button>
                    {documentoAberto && acoesDocumento({
                        idDocumento: documentoAberto.idDocumento,
                        campo: documentoAberto.campo,
                        titulo: documentoAberto.titulo,
                        status: documentos.find((d) => d.idDocumento === documentoAberto.idDocumento)?.[`${documentoAberto.campo}Status`],
                    })}
                </DialogActions>
            </Dialog>

            {/* Motivo da rejeição do documento (o cliente vê este texto no painel) */}
            <Dialog open={!!rejeicao} onClose={() => !avaliandoDocumento && setRejeicao(null)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontSize: 17, fontWeight: 600 }}>Rejeitar documento</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {rejeicao?.titulo}. O cliente verá o motivo no painel e poderá enviar o arquivo novamente.
                    </Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                        {MOTIVOS_REJEICAO_SUGERIDOS.map((sugestao) => (
                            <Chip key={sugestao} size="small" variant="outlined" label={sugestao} onClick={() => setRejeicao((r) => ({ ...r, motivo: sugestao }))} />
                        ))}
                    </Box>
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        minRows={3}
                        label="Motivo da rejeição"
                        value={rejeicao?.motivo || ""}
                        onChange={(e) => setRejeicao((r) => ({ ...r, motivo: e.target.value.slice(0, MAX_MOTIVO_REJEICAO) }))}
                        helperText={`${(rejeicao?.motivo || "").length}/${MAX_MOTIVO_REJEICAO}`}
                    />
                </DialogContent>
                <DialogActions>
                    <Button size="small" sx={{ textTransform: "none" }} disabled={!!avaliandoDocumento} onClick={() => setRejeicao(null)}>
                        Cancelar
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        color="error"
                        sx={{ textTransform: "none" }}
                        disabled={!rejeicao?.motivo.trim()}
                        loading={!!avaliandoDocumento}
                        onClick={handleConfirmarRejeicao}
                    >
                        Rejeitar documento
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default PerfilUsuario;
